import { render, staticRenderFns } from "./taskCardMenu.vue?vue&type=template&id=70d4dfea&"
import script from "./taskCardMenu.vue?vue&type=script&lang=js&"
export * from "./taskCardMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports